export default __webpack_public_path__ + "static/media/arbitrage.8e547bcd.svg";